module.exports = __webpack_public_path__ + "media/assets/misc/gradient-bg-a66e3320b61a61618103970a7eb7a119.png";